import { REFUND_ROUTES, REFUND_ROUTES_MAP } from '../model/constants';
export const getRefundPrevPath = (currentPath, { skipPassengers, skipReasons }) => {
    var _a, _b;
    const prevPath = (_b = (_a = REFUND_ROUTES_MAP.get(currentPath)) === null || _a === void 0 ? void 0 : _a.prev) !== null && _b !== void 0 ? _b : null;
    if (!prevPath) {
        return null;
    }
    if (prevPath === REFUND_ROUTES.PASSENGERS && skipPassengers) {
        return null;
    }
    if (prevPath === REFUND_ROUTES.REASONS && skipReasons) {
        return skipPassengers ? null : REFUND_ROUTES.PASSENGERS;
    }
    return prevPath;
};
